import React from "react";
import "./NotClickable.scss";

import fence from "../../assets/fencelong.png";
import fenceshort from "../../assets/fence.png";
import gate from "../../assets/brama.png";
import kratki_dluga from "../../assets/buildings/kratki_dluga.png";
import kratki_krotka from "../../assets/buildings/kratki_krotka.png";
import kratki_podwojne from "../../assets/buildings/kratki_podwojne.png";
import kratki_krotsza from "../../assets/buildings/kratki_krotsza.png";
import kratka_dluzsza from "../../assets/buildings/kratka_dluzsza.png";
import roadpic2 from "../../assets/road2.png";
import roadpic from "../../assets/road3.png";
import office from "../../assets/buildings/office.png";
import office2 from "../../assets/buildings/office2.png";
import korytko from "../../assets/buildings/korytko.png";
import korytko2 from "../../assets/buildings/korytko2.png";
import korytko3 from "../../assets/buildings/korytko3.png";
import wlot from "../../assets/buildings/wlot.png"
import wylot from "../../assets/buildings/wylot.png"

import barpom from "../../assets/barpom.png";
import barwyl from "../../assets/barwyl.png";



function NotClickable() {
  return (
    <>

      <img className="road" src={roadpic} alt="" />
      <img className="office" src={office} alt="" />
      <img className="office2" src={office2} alt="" />
      <img className="fence" src={fence} alt="" />
      <img className="fenceshort" src={fenceshort} alt="" />
      <img className="gate" src={gate} alt="" />
      <img className="kratki_dluga" src={kratki_dluga} alt="" />
      <img className="kratki_krotka" src={kratki_krotka} alt="" />
      <img className="kratki_podwojne" src={kratki_podwojne} alt="" />
      <img className="kratki_krotsza" src={kratki_krotsza} alt="" />
      <img className="kratka_dluzsza" src={kratka_dluzsza} alt="" />
      <img className="road2" src={roadpic2} alt="" />
      <img className="korytko" src={korytko} alt="" />
      <img className="korytko2" src={korytko2} alt="" />
      <img className="korytko3" src={korytko3} alt="" />
      <img className="wlot" src={wlot} alt="" />
      <img className="wylot" src={wylot} alt="" />
      {/* <img className="barpom" src={barpom} alt="" />
      <img className="barwyl" src={barwyl} alt="" /> */}
    </>
  );
}

export default NotClickable;
